interface Props {
  available: string[]
  selected: string[]
  disabled?: boolean
  onChange: (properties: string[]) => void
}

const ALL = '*'

/**
 * Which properties an account may read.
 *
 * "All properties" is a distinct choice rather than every box ticked, because it means
 * something different: it keeps covering properties added later. Ticking each one is a
 * fixed list that a new site does not join.
 */
export function PropertyPicker({ available, selected, disabled = false, onChange }: Props) {
  const everything = selected.includes(ALL)

  function toggle(propertyId: string, checked: boolean) {
    const next = checked
      ? [...selected.filter((entry) => entry !== ALL), propertyId]
      : selected.filter((entry) => entry !== propertyId && entry !== ALL)
    onChange(next)
  }

  return (
    <div className="picker">
      <label className="checkbox">
        <input
          type="checkbox"
          checked={everything}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked ? [ALL] : [])}
        />
        <span>All properties</span>
      </label>

      {!everything &&
        available.map((propertyId) => (
          <label className="checkbox" key={propertyId}>
            <input
              type="checkbox"
              checked={selected.includes(propertyId)}
              disabled={disabled}
              onChange={(event) => toggle(propertyId, event.target.checked)}
            />
            <span>{propertyId}</span>
          </label>
        ))}

      {!everything && available.length === 0 && (
        <span className="picker__empty">No properties configured yet</span>
      )}
    </div>
  )
}
